/** 案件で求める条件：メンバー構成 ジュニアメンバー重視 */
export const RFP_REQUIRED_CONDITION_MEMBER_COMPOSITION_JUNIOR = {
    label: 'ジュニアメンバー重視',
    labelWithLf: 'ジュニアメンバー\n重視',
    value: 1,
};
/** 案件で求める条件：メンバー構成 バランス型 */
export const RFP_REQUIRED_CONDITION_MEMBER_COMPOSITION_AVERAGE = {
    label: 'バランス型',
    labelWithLf: 'バランス型',
    value: 2,
};
/** 案件で求める条件：メンバー構成 シニアメンバー重視 */
export const RFP_REQUIRED_CONDITION_MEMBER_COMPOSITION_SENIOR = {
    label: 'シニアメンバー重視',
    labelWithLf: 'シニアメンバー\n重視',
    value: 3,
};
/** 案件で求める条件：メンバー構成の一覧 */
export const RFP_REQUIRED_CONDITION_MEMBER_COMPOSITIONS = [
    RFP_REQUIRED_CONDITION_MEMBER_COMPOSITION_JUNIOR,
    RFP_REQUIRED_CONDITION_MEMBER_COMPOSITION_AVERAGE,
    RFP_REQUIRED_CONDITION_MEMBER_COMPOSITION_SENIOR,
];
